import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { observer } from "mobx-react-lite";
import { BrowserRouter } from "react-router-dom";
import { MAIN_PAGE } from "config";

import NotFound from "../../pages/NotFound";
import NewStaking from "../../pages/NewStaking";
import { Header, NotificationContainer, Notify } from "@airdao/ui-library";
import { useAccount } from "wagmi";

const { REACT_APP_CHAIN_ID: envChainId } = process.env;

const RenderRoutes = observer(() => {
  const { isConnected, chainId } = useAccount();

  useEffect(() => {
    if (isConnected && chainId !== +envChainId) {
      Notify.info(
        "Please switch to the correct network in your wallet.",
        null,
        {
          toastId: "switch-network",
        }
      );
    } else {
      Notify.dismiss("switch-network");
    }
  }, [chainId, isConnected]);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Header chainId={+envChainId} />
      <NotificationContainer />
      <Switch>
        <Route path={MAIN_PAGE} exact component={NewStaking} />
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
});

export default RenderRoutes;
